import React, { useMemo, useState } from "react";
import Modal from "@/components/ui/modal";
import Dropdown from "@/components/ui/dropdown";

interface UserOption {
  id: string;
  name: string;
}

interface Props {
  isOpen: boolean;
  loading?: boolean;
  users: UserOption[];
  onClose: () => void;
  onSubmit: (userIds: string[]) => void;
}

const AddMemberModal: React.FC<Props> = ({ isOpen, loading, users, onClose, onSubmit }) => {
  const [selected, setSelected] = useState<string[]>([]);

  const options = useMemo(
    () => users.map((u) => ({ label: u.name, value: u.id })),
    [users],
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Personel Ekle"
      withForm
      loading={loading}
      handleSubmit={(e) => {
        e.preventDefault();
        onSubmit(selected);
      }}
      isFormValid={selected.length > 0}
    >
      <Dropdown
        label="Personeller"
        options={options}
        multiple
        searchable
        value={selected}
        onSelect={(v) => setSelected(Array.isArray(v) ? v : [v])}
      />
    </Modal>
  );
};

export default AddMemberModal;
